import { api } from './client'

/**
 * Global search — SUPER_ADMIN and PROGRAM_ADMIN only.
 * Returns { users, programs, courses, sessions }.
 */
export const globalSearch = (q) =>
  api.get('/search', { params: { q } }).then((r) => r.data)
